import React from 'react';
import PropTypes from 'prop-types';
import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import { useConfigValue } from '../../../hooks/useConfigValue';
import { invoicePropType } from '../../../types/invoice';

import Image from '../../Image';
import ProductsList from '../../Products/ProductsList';
import PaymentDetails from '../PaymentDetails';
import InfoBox from '../InfoBox';

const InvoiceDetails = ({ invoice, theme, i18n }) => {
    const { formatPrice, formatMessage, formatDate } = i18n;

    const { myPage: { logoIcon } } = useConfigValue();
    const {
        productName,
        invoiceDate,
        orderId,
        total,
        invoiceItems,
    } = invoice;

    return (
        <div className={ theme.invoiceDetails }>
            <div className={ theme.box }>
                <div className={ theme.logoWrapper }>
                    <Image imageAsset={ logoIcon } theme={ theme } />
                </div>
                <div className={ theme.params }>
                    <span className={ theme.name }>
                        { productName }
                    </span>
                    <span className={ theme.details }>
                        { formatMessage('invoices.details.date', { date: formatDate(invoiceDate) }) }
                    </span>
                    { orderId && (
                        <span className={ theme.details }>
                            { formatMessage('invoices.details.orderNumber', { order: orderId }) }
                        </span>
                    )}
                    <span className={ theme.price }>
                        { formatPrice(total) }
                    </span>
                </div>
            </div>
            <ProductsList products={ invoiceItems } total={ total } />
            <PaymentDetails invoice={ invoice } />
            <InfoBox invoice={ invoice } theme={ theme } />
        </div>
    );
};

InvoiceDetails.propTypes = {
    invoice: invoicePropType,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default intlEquipped(InvoiceDetails);
